// Trava real da rolagem da página quando um painel/modal em tela cheia abre.
// Ver CORRECAO_EMERGENT_MASCOTE_TRAVA_TELA — no iOS Safari o
// `body { overflow: hidden }` sozinho não trava; precisa fixar o body na
// posição atual e devolver a rolagem ao fechar. Retorna a função de liberação.
export function trancarPagina() {
  if (typeof window === "undefined") return () => {};
  const scrollY = window.scrollY || window.pageYOffset || 0;
  const html = document.documentElement;
  const body = document.body;
  const prev = {
    bodyPos: body.style.position,
    bodyTop: body.style.top,
    bodyWidth: body.style.width,
    bodyOverflow: body.style.overflow,
    htmlOverscroll: html.style.overscrollBehavior,
  };
  body.style.position = "fixed";
  body.style.top = `-${scrollY}px`;
  body.style.width = "100%";
  body.style.overflow = "hidden";
  html.style.overscrollBehavior = "contain";
  return () => {
    body.style.position = prev.bodyPos;
    body.style.top = prev.bodyTop;
    body.style.width = prev.bodyWidth;
    body.style.overflow = prev.bodyOverflow;
    html.style.overscrollBehavior = prev.htmlOverscroll;
    window.scrollTo(0, scrollY);
  };
}
